///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { BomDTO, BomNodeDTO } from '../../../generated/shared-types.model';
import { ExtendedBomDeviceDTO } from './dto/extended-bom-device-dto.model';

export class BomReportUtils {
    public static convertBomToMap(bom: BomDTO): Map<string, ExtendedBomDeviceDTO[]> {
        const resultMap = new Map<string, ExtendedBomDeviceDTO[]>();

        if (!bom?.nodes || bom.nodes.length === 0) {
            return resultMap;
        }

        bom.nodes.forEach((node: BomNodeDTO) => {
            if (node.devices && node.devices.length > 0) {
                resultMap.set(
                    node.name,
                    node.devices.map((device) => ExtendedBomDeviceDTO.fromDeviceDto(device))
                );
            }
        });

        return resultMap;
    }

    public static secondaryNodesIncludeNodeName(secondaryNodes: string, nodeName: string): boolean {
        if (!secondaryNodes) {
            return false;
        }
        const namesArray = secondaryNodes.split(', ');
        return namesArray.includes(nodeName);
    }
}
